<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">報告中心</h1>
        <p class="page-subtitle">選擇需要查看的報告類型</p>
      </div>
      <div class="header-right">
        <!-- 可扩展添加刷新/导出等按钮 -->
      </div>
    </div>

    <div class="layout">
      <!-- 报告列表容器 -->
      <div class="report-container">
        <!-- PC端网格卡片（≥768px显示） -->
        <div class="pc-grid">
          <div
              class="report-card"
              v-for="(item, index) in list"
              :key="index"
              @click="onClicked(item.path)"
          >
            <div class="card-icon">
              <i :class="getReportIcon(item.title)"></i>
            </div>
            <div class="card-content">
              <div class="card-title">{{ item.title }}</div>
              <div class="card-desc">{{ getReportDesc(item.title) }}</div>
            </div>
            <div class="card-arrow">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>

        <!-- 手机端列表卡片（<768px显示） -->
        <div class="mobile-list">
          <div
              class="report-item"
              v-for="(item, index) in list"
              :key="index"
              @click="onClicked(item.path)"
          >
            <div class="item-icon">
              <i :class="getReportIcon(item.title)"></i>
            </div>
            <div class="item-content">
              <div class="item-title">{{ item.title }}</div>
              <div class="item-desc">{{ getReportDesc(item.title) }}</div>
            </div>
            <div class="item-arrow">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          title: "年級銷售統計",
          path: "/report/course-sales-statistics",
        },
        {
          title: "學習表現冒險模式",
          path: "/report/adventure-mode-report",
        },
        {
          title: "學習表現作業",
          path: "/report/school-assignment-report",
        },
        {
          title: "推廣碼報告",
          path: "/report/promotion-code-report",
        },
        {
          title: "激活統計報告",
          path: "/report/activate-report",
        },
        {
          title: "老師激活學生統計報告",
          path: "/report/teacher-activate-report",
        },
        {
          title: "學生登錄統計",
          path: "/report/studentLoginLog",
        },
        {
          title: "Email發送記錄",
          path: "/report/emailLog",
        },
      ],
    };
  },
  methods: {
    // 根据报告标题获取对应图标
    getReportIcon(title) {
      const iconMap = {
        "年級銷售統計": "el-icon-s-data",
        "學習表現冒險模式": "el-icon-user-solid",
        "學習表現作業": "el-icon-edit-outline",
        "推廣碼報告": "el-icon-share",
        "激活統計報告": "el-icon-mobile-phone",
        "老師激活學生統計報告": "el-icon-mobile-phone"
      };
      return iconMap[title] || "el-icon-document";
    },
    // 根据报告标题获取描述
    getReportDesc(title) {
      const descMap = {
        "年級銷售統計": "查看各年級課程銷售數據統計",
        "學習表現冒險模式": "查看學生冒險模式學習表現數據",
        "學習表現作業": "查看學生作業完成情況及學習表現",
        "推廣碼報告": "查看推廣碼使用情況及效果統計",
        "激活統計報告": "查看分校學生賬戶激活數量及相關統計數據",
        "老師激活學生統計報告": "查看老師激活學生數量及相關統計數據"
      };
      return descMap[title] || "查看詳細報告數據";
    },
    // 跳转报告页面
    onClicked(path) {
      this.$router.push({ path: path });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

/* 统一风格页头 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;

  .header-left {
    .page-title {
      font-size: 22px;
      font-weight: 600;
      color: #B62D2E;
      margin: 0 0 4px 0;
    }
    .page-subtitle {
      font-size: 14px;
      color: #6c757d;
      margin: 0;
    }
  }

  .header-right {
    display: flex;
    gap: 8px;
  }
}

/* 布局容器 */
.layout {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 报告列表容器 */
.report-container {
  width: 100%;

  /* PC端网格卡片样式 */
  .pc-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;

    .report-card {
      display: flex;
      align-items: center;
      padding: 20px;
      background: linear-gradient(135deg, #eeeeee 0%, #ffffff 100%);
      border-radius: 12px;
      cursor: pointer;
      transition: all 0.3s ease;
      border: 1px solid #dee2e6;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
        border-color: #ecaf28;
      }

      .card-icon {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: #FCC03A;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        margin-right: 16px;
        flex-shrink: 0;
      }

      .card-content {
        flex: 1;

        .card-title {
          font-size: 18px;
          font-weight: 600;
          color: #1f2937;
          margin-bottom: 4px;
        }

        .card-desc {
          font-size: 14px;
          color: #6c757d;
          line-height: 1.4;
        }
      }

      .card-arrow {
        color: #ecaf28;
        font-size: 16px;
        margin-left: 8px;
      }
    }
  }

  /* 手机端列表卡片样式 */
  .mobile-list {
    display: none;
    flex-direction: column;
    gap: 12px;

    .report-item {
      display: flex;
      align-items: center;
      padding: 16px;
      background-color: #f8f9fa;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s ease;
      border: 1px solid #e9ecef;

      &:hover {
        border-color: #166ea5;
        background-color: #f1f3f5;
      }

      .item-icon {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #FCC03A;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        margin-right: 12px;
        flex-shrink: 0;
      }

      .item-content {
        flex: 1;

        .item-title {
          font-size: 16px;
          font-weight: 600;
          color: #1f2937;
          margin-bottom: 2px;
        }

        .item-desc {
          font-size: 12px;
          color: #6c757d;
          line-height: 1.3;
        }
      }

      .item-arrow {
        color: #166ea5;
        font-size: 14px;
        margin-left: 8px;
      }
    }
  }
}

/* 响应式适配 */
@media (max-width: 768px) {
  .page {
    padding: 8px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding-bottom: 12px;
  }

  .layout {
    padding: 16px;
  }

  /* 隐藏PC网格，显示手机列表 */
  .report-container .pc-grid {
    display: none;
  }

  .report-container .mobile-list {
    display: flex;
  }
}

/* 适配平板屏幕 */
@media (min-width: 769px) and (max-width: 1024px) {
  .report-container .pc-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
}
</style>